// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"152":"3ae31fba","200":"5937c15b","287":"dd52a5ea","290":"23ea045c","453":"612f53fa","550":"a4d5683c","608":"6284f6b6","841":"0f18438b"}[chunkId] + ".chunk.js";
};